import { AwsRum, AwsRumConfig } from 'aws-rum-web'

let rumInstance: AwsRum | null = null

try {
  const isEnabled = import.meta.env.VITE_AWS_RUM_ENABLED === 'true'
  const applicationId = import.meta.env.VITE_AWS_RUM_APPLICATION_ID
  const identityPoolId = import.meta.env.VITE_AWS_RUM_IDENTITY_POOL_ID
  const endpoint = import.meta.env.VITE_AWS_RUM_ENDPOINT || 'https://dataplane.rum.eu-north-1.amazonaws.com'
  const region = import.meta.env.VITE_AWS_REGION || 'eu-north-1'

  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

  if (isEnabled && applicationId && identityPoolId && !isLocalhost) {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId,
      endpoint,
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true,
    }

    rumInstance = new AwsRum(applicationId, import.meta.env.VITE_APP_VERSION || '1.0.0', region, config)
  }
} catch {
  // RUM must never break the app
}

export const rum = rumInstance
